/* Complete, consent-gated cart snapshots for the draft recovery flows. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.rotCartRecovery = api.createWriter(root);
})(typeof window === 'undefined' ? {} : window, function () {
  'use strict';
  function snapshot(cart, now = new Date()) {
    if (!Array.isArray(cart?.items)) return null;
    const merchandise = cart.items.filter(item => !(/^re:?do$/i.test(String(item.vendor || '').trim()) && /^x-redo/i.test(String(item.sku || ''))));
    let supported = merchandise.length > 0;
    const quantities = new Map();
    const items = merchandise.map(item => {
      const id = String(item.variant_id || item.id || '');
      const quantity = Number(item.quantity);
      if (!/^\d+$/.test(id) || !Number.isSafeInteger(quantity) || quantity <= 0 || item.selling_plan_allocation || item.gift_card || item.parent_relationship || Object.keys(item.properties || {}).length) supported = false;
      quantities.set(id, (quantities.get(id) || 0) + quantity);
      return {variant_id:id, product_id:String(item.product_id || ''), title:String(item.product_title || item.title || ''), variant:String(item.variant_title || ''), quantity, image:String(item.image || item.featured_image?.url || ''), line_price:Number(item.final_line_price ?? item.line_price ?? item.original_line_price ?? 0) / 100};
    });
    const applications = [...(cart.cart_level_discount_applications || []), ...merchandise.flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application).filter(Boolean))];
    const codes = [...new Set([...(cart.discount_codes || []).filter(code => code.applicable !== false).map(code => code.code), ...applications.filter(application => application.type === 'discount_code').map(application => application.title)].filter(Boolean))];
    const path = '/cart/' + [...quantities].map(([id, quantity]) => id + ':' + quantity).join(',') + '?storefront=true' + (codes.length ? '&discount=' + encodeURIComponent(codes.join(',')) : '');
    if (path.length > 1800) supported = false;
    const discounted = codes.length > 0 || Number(cart.total_discount || 0) > 0 || (cart.cart_level_discount_applications || []).length > 0 || merchandise.some(item => Number(item.final_line_price ?? item.line_price) < Number(item.original_line_price ?? item.line_price));
    return {
      ROT_CartVersion:1,
      ROT_CartItems:items,
      ROT_CartProductIds:[...new Set(items.map(item => item.product_id))],
      ROT_CartItemCount:items.reduce((sum, item) => sum + item.quantity, 0),
      ROT_CartUrl:supported ? 'https://ruleofthreads.com' + path : '',
      ROT_CartRestoreSupported:supported,
      ROT_CartCurrency:String(cart.currency || ''),
      ROT_CartOfferEligible:supported && cart.currency === 'USD' && !discounted && items.reduce((sum, item) => sum + item.line_price, 0) > 0,
      ROT_CartUpdatedAt:now.toISOString()
    };
  }
  function createWriter(win) {
    let latest, running = false, sent = '', timer, known = false, sentCount = null, lastError = '';
    const allowed = () => {
      const privacy = win.Shopify?.customerPrivacy;
      return Boolean(typeof privacy?.marketingAllowed === 'function' && typeof privacy?.analyticsProcessingAllowed === 'function' && privacy.marketingAllowed() && privacy.analyticsProcessingAllowed());
    };
    async function flush() {
      if (running || !latest || !allowed()) return;
      const client = win.klaviyo;
      if (typeof client?.isIdentified !== 'function' || typeof client?.identify !== 'function') return;
      running = true;
      try {
        known = await client.isIdentified();
        if (!known || !allowed()) return;
        while (latest && allowed()) {
          const current = latest;
          const fingerprint = JSON.stringify({...current, ROT_CartUpdatedAt:undefined});
          if (sent === fingerprint) break;
          await client.identify(current);
          sent = fingerprint;
          sentCount = current.ROT_CartItemCount;
          lastError = '';
          if (latest === current) break;
        }
      } catch { lastError = 'Snapshot was not saved.'; }
      finally { running = false; }
    }
    function update(cart) {
      latest = snapshot(cart);
      clearTimeout(timer);
      timer = setTimeout(flush, 250);
    }
    win.document.addEventListener('visitorConsentCollected', flush);
    win.addEventListener('klaviyoForms', event => { if (event.detail?.type === 'submit') setTimeout(flush, 1000); });
    // Bounded retry for the existing deferred Klaviyo and Shopify privacy loaders.
    [1500, 5000].forEach(delay => setTimeout(flush, delay));
    return {update, retry:flush, getStatus:() => ({permission:allowed(),known,pendingCount:latest?.ROT_CartItemCount,sentCount,lastError})};
  }
  return {snapshot, createWriter};
});
